
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index';
import { useLocation } from 'react-router-dom';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import CookieConsent from './components/feature/CookieConsent';

function AppContent() {
  const location = useLocation();
  const isBlogPage = location.pathname === '/blog';

  return (
    <div className="min-h-screen flex flex-col">
      {!isBlogPage && <Header />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isBlogPage && <Footer />}
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
